<template>
    <div>
      <v-text-field
        box
        :label="label"
        v-model="search"
        append-icon="person_search"
        @keyup.enter="listCountries()"
        v-if="show == 'input'"
      ></v-text-field>
      <v-select
        box
        :label="label"
        v-model="selectedCountry"
        clearable
        :items="items"
        v-if="show == 'select'"
      ></v-select>
    </div>
  </template>
  
  <script>
  import CountriesWithCode from "../../shared/CountriesWithCode"
  
  export default {
    name: 'CountrySelect',
    props: {
      label: {
        type: String
      },
      model: {
        type: String
      }
    },
    data() {
      return {
        entries: [],
        search: null,
        show: 'input',
        isLoading: false,
        selectedCountry: this.model,
        coutries: CountriesWithCode
      }
    },
    computed: {
      items () {
        return this.entries.map(entry => {
          return {value: entry.value, text: entry.text}
        })
      }
    },
    watch: {
      selectedCountry (val, old_val) {
  
        if(val == null && typeof(old_val) == 'undefined') return
  
        if ((typeof(val) == 'undefined' || val == null || val == "")) {
          this.selectedCountry = null
          this.search = ""
          this.$emit('onSelectedCountry', null)
          this.$nextTick(()=>{ this.show = 'input' })
          return
        } else if ((typeof(old_val) == 'undefined' || old_val == null) ) {
          this.$emit('onSelectedCountry', val)
          this.$nextTick(()=>{ this.show = 'select' })
          return
        } else if (typeof(val) !== 'undefined' && val != old_val) {
          if(typeof(val) == 'object') {
            this.show = 'select'
            this.$emit('onSelectedCountry', val)
          } else {
            var new_var = this.getCountryByIsoCode(val)
            this.$emit('onSelectedCountry', new_var)
          }
        }
      }
    },
    methods: {
      listCountries () {
          if(this.search !== null) {
            this.entries = this.coutries.filter(country => country.text.toUpperCase().includes(this.search.toUpperCase()));
  
            if (this.entries.length != 0) {
              this.selectedCountry = this.entries[0]
            } else return
  
          } else {
            this.entries = this.coutries
            this.selectedCountry = this.entries[0]
          }
      },
      getCountryByIsoCode(val) {
        return this.coutries.find(country => country.value == val);
      }
    }
  }
  </script>
  <style>
  </style>
  


// WEBPACK FOOTER //
// src/components/filters/CountrySelect.vue